import { Grid, Typography } from '@mui/material';
import SingleChart from '../SingleChart';
import { type CircleChartDataWrapper } from 'src/shared/types/charts';
import { CardNoFlex, GridWrapper, GridAlignEnd, GridDisabledWrapper } from './styles';
import DisabledMask from 'src/shared/components/DisabledMask';

type DoubleCircleChartProps = {
  chartData: CircleChartDataWrapper;
  disabled: boolean;
};

const DoubleCircleChart = ({ chartData, disabled }: DoubleCircleChartProps) => {
  if (disabled) {
    return (
      <GridDisabledWrapper item container xs={12}>
        <DisabledMask />
      </GridDisabledWrapper>
    );
  }
  return (
    <GridWrapper item container xs={12}>
      <Grid item>
        <CardNoFlex title={<Typography variant="h2">{chartData?.title}</Typography>} />
      </Grid>
      <GridAlignEnd container item spacing={3}>
        {chartData?.data?.map((data, index) => (
          <Grid key={`doubleCircleChart-${index}`} item xs={12} sm={6}>
            <SingleChart data={data} />
          </Grid>
        ))}
      </GridAlignEnd>
    </GridWrapper>
  );
};

export default DoubleCircleChart;
